"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPart = exports.hasPart = exports.getScripts = exports.hasScripts = void 0;
// This file is auto-generated. Modify the script that creates it.
var _95_1 = require("./Scripts/95");
var _97_1 = require("./Scripts/97");
var _98_1 = require("./Scripts/98");
var _99_1 = require("./Scripts/99");
var _100_1 = require("./Scripts/100");
var _101_1 = require("./Scripts/101");
var _102_1 = require("./Scripts/102");
var _103_1 = require("./Scripts/103");
var _104_1 = require("./Scripts/104");
var _105_1 = require("./Scripts/105");
var _106_1 = require("./Scripts/106");
var _107_1 = require("./Scripts/107");
var _108_1 = require("./Scripts/108");
var _109_1 = require("./Scripts/109");
var _110_1 = require("./Scripts/110");
var _111_1 = require("./Scripts/111");
var _112_1 = require("./Scripts/112");
var _113_1 = require("./Scripts/113");
var _114_1 = require("./Scripts/114");
var _115_1 = require("./Scripts/115");
var _116_1 = require("./Scripts/116");
var _117_1 = require("./Scripts/117");
var _118_1 = require("./Scripts/118");
var _119_1 = require("./Scripts/119");
var _120_1 = require("./Scripts/120");
var _121_1 = require("./Scripts/121");
var _122_1 = require("./Scripts/122");
exports.hasScripts = function (key) {
    if (!key || key.length === 0)
        return false;
    switch (key.slice(0, 1).charCodeAt(0)) {
        case 95: return _95_1.f95.hasOwnProperty(key);
        case 97: return _97_1.f97.hasOwnProperty(key);
        case 98: return _98_1.f98.hasOwnProperty(key);
        case 99: return _99_1.f99.hasOwnProperty(key);
        case 100: return _100_1.f100.hasOwnProperty(key);
        case 101: return _101_1.f101.hasOwnProperty(key);
        case 102: return _102_1.f102.hasOwnProperty(key);
        case 103: return _103_1.f103.hasOwnProperty(key);
        case 104: return _104_1.f104.hasOwnProperty(key);
        case 105: return _105_1.f105.hasOwnProperty(key);
        case 106: return _106_1.f106.hasOwnProperty(key);
        case 107: return _107_1.f107.hasOwnProperty(key);
        case 108: return _108_1.f108.hasOwnProperty(key);
        case 109: return _109_1.f109.hasOwnProperty(key);
        case 110: return _110_1.f110.hasOwnProperty(key);
        case 111: return _111_1.f111.hasOwnProperty(key);
        case 112: return _112_1.f112.hasOwnProperty(key);
        case 113: return _113_1.f113.hasOwnProperty(key);
        case 114: return _114_1.f114.hasOwnProperty(key);
        case 115: return _115_1.f115.hasOwnProperty(key);
        case 116: return _116_1.f116.hasOwnProperty(key);
        case 117: return _117_1.f117.hasOwnProperty(key);
        case 118: return _118_1.f118.hasOwnProperty(key);
        case 119: return _119_1.f119.hasOwnProperty(key);
        case 120: return _120_1.f120.hasOwnProperty(key);
        case 121: return _121_1.f121.hasOwnProperty(key);
        case 122: return _122_1.f122.hasOwnProperty(key);
        default: return false;
    }
};
exports.getScripts = function (key) {
    if (!key || key.length === 0)
        return [];
    switch (key.slice(0, 1).charCodeAt(0)) {
        case 95: return _95_1.f95[key];
        case 97: return _97_1.f97[key];
        case 98: return _98_1.f98[key];
        case 99: return _99_1.f99[key];
        case 100: return _100_1.f100[key];
        case 101: return _101_1.f101[key];
        case 102: return _102_1.f102[key];
        case 103: return _103_1.f103[key];
        case 104: return _104_1.f104[key];
        case 105: return _105_1.f105[key];
        case 106: return _106_1.f106[key];
        case 107: return _107_1.f107[key];
        case 108: return _108_1.f108[key];
        case 109: return _109_1.f109[key];
        case 110: return _110_1.f110[key];
        case 111: return _111_1.f111[key];
        case 112: return _112_1.f112[key];
        case 113: return _113_1.f113[key];
        case 114: return _114_1.f114[key];
        case 115: return _115_1.f115[key];
        case 116: return _116_1.f116[key];
        case 117: return _117_1.f117[key];
        case 118: return _118_1.f118[key];
        case 119: return _119_1.f119[key];
        case 120: return _120_1.f120[key];
        case 121: return _121_1.f121[key];
        case 122: return _122_1.f122[key];
        default: return [];
    }
};
exports.hasPart = function (key) {
    if (!key || key.length === 0)
        return false;
    switch (key.slice(0, 1).charCodeAt(0)) {
        case 95: return true;
        case 97: return true;
        case 98: return true;
        case 99: return true;
        case 100: return true;
        case 101: return true;
        case 102: return true;
        case 103: return true;
        case 104: return true;
        case 105: return true;
        case 106: return true;
        case 107: return true;
        case 108: return true;
        case 109: return true;
        case 110: return true;
        case 111: return true;
        case 112: return true;
        case 113: return true;
        case 114: return true;
        case 115: return true;
        case 116: return true;
        case 117: return true;
        case 118: return true;
        case 119: return true;
        case 120: return true;
        case 121: return true;
        case 122: return true;
        default: return false;
    }
};
exports.getPart = function (key) {
    if (!key || key.length === 0)
        return [];
    switch (key.slice(0, 1).charCodeAt(0)) {
        case 95: return _95_1.f95;
        case 97: return _97_1.f97;
        case 98: return _98_1.f98;
        case 99: return _99_1.f99;
        case 100: return _100_1.f100;
        case 101: return _101_1.f101;
        case 102: return _102_1.f102;
        case 103: return _103_1.f103;
        case 104: return _104_1.f104;
        case 105: return _105_1.f105;
        case 106: return _106_1.f106;
        case 107: return _107_1.f107;
        case 108: return _108_1.f108;
        case 109: return _109_1.f109;
        case 110: return _110_1.f110;
        case 111: return _111_1.f111;
        case 112: return _112_1.f112;
        case 113: return _113_1.f113;
        case 114: return _114_1.f114;
        case 115: return _115_1.f115;
        case 116: return _116_1.f116;
        case 117: return _117_1.f117;
        case 118: return _118_1.f118;
        case 119: return _119_1.f119;
        case 120: return _120_1.f120;
        case 121: return _121_1.f121;
        case 122: return _122_1.f122;
        default: return [];
    }
};
